export enum JobCardSection {
  INSPECTION = "INSPECTION",
  WORK_DONE = "WORK_DONE",
}

export type JobCardOpenSections = Record<JobCardSection, boolean>;

// Only the newest job opens its inspection; older ones keep the card short but still show what was done.
export const defaultOpenSections = (isMostRecent: boolean): JobCardOpenSections => ({
  [JobCardSection.INSPECTION]: isMostRecent,
  [JobCardSection.WORK_DONE]: true,
});
